// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CovidEmergency from '../_raw/service/icon_covid_emergency.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CovidEmergency);
